import axios from 'axios';
import { getSessionToken } from '@descope/react-sdk';
import { AppMode } from '@/lib/config/types';

interface StoredConfig {
  mode?: AppMode;
  localBaseUrl?: string;
  localTenantId?: string;
  [key: string]: unknown;
}

const getStoredConfig = (): StoredConfig | null => {
  try {
    const stored = localStorage.getItem('harmony-management-config');
    if (stored) {
      return JSON.parse(stored) as StoredConfig;
    }
  } catch (error) {
    console.error('Failed to load config from localStorage:', error);
  }
  return null;
};

export const integrationsClient = axios.create();

let interceptorId: number | null = null;

export const configureIntegrationsClient = (): void => {
  try {
    const config = getStoredConfig();
    const mode = config?.mode ?? AppMode.REMOTE;

    const baseUrl = mode === AppMode.LOCAL
      ? `${config?.localBaseUrl ?? 'http://localhost:8000'}/api/v1`
      : `${import.meta.env.VITE_API_BASE_URL || 'https://api.dev.us1.harmony.so'}/settings/api/v1`;

    integrationsClient.defaults.baseURL = baseUrl;

    if (interceptorId !== null) {
      integrationsClient.interceptors.request.eject(interceptorId);
    }

    interceptorId = integrationsClient.interceptors.request.use((v) => {
      try {
        if (mode === AppMode.REMOTE) {
          const token = getSessionToken();
          if (token) {
            v.headers.set('Authorization', `Bearer ${token}`);
          }
        } else {
          const localTenantId = config?.localTenantId;
          if (localTenantId) {
            v.headers.set('x-tenant-id', localTenantId);
          }
        }
      } catch (error: unknown) {
        console.error('Failed to configure Integrations request headers:', error);
      }
      return v;
    });
  } catch (error) {
    console.error('Failed to configure Integrations client:', error);
  }
};

configureIntegrationsClient();
